// extracted by mini-css-extract-plugin
module.exports = {"container":"submitButton_container__20Egq","text":"submitButton_text__3E--i"};